<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>
<script lang="ts" setup>
import type {Area} from "#magnolia-layer/types/magnolia-types";
import type {LinkTypes} from "#magnolia-layer/types/api";

const props = defineProps<{
  metadata: Area;
  title: string;
  text?: string;
  link?: LinkTypes;
}>();

const resolvedLink = props.link ? resolveLink(props) : undefined;
</script>

<template>
  <article
    class="col-span-full border-t-[1px] border-t-neutral-600 overflow-x-clip grid items-center justify-center auto-rows-fr px-8 grid-cols-[100%]">
    <div class="lg:inner-content-grid col-[1] row-[1] z-10 pt-12 lg:pt-22">
      <div class="text-white lg:col-start-4 lg:col-span-6">
        <TextLayout :link="resolvedLink" :title>
          <div v-html="text"></div>
        </TextLayout>
      </div>
    </div>
    <LazyRendering
      class="col-[1] row-[1/3] min-h-[540px] flex self-end items-end justify-center"></LazyRendering>
  </article>
</template>

<style lang="scss" scoped></style>
